module.exports = __webpack_public_path__ + "img/グループ 228.e52cb1dd.png";